import { render, staticRenderFns } from "./manyidu_page.vue?vue&type=template&id=2d30685c&scoped=true"
import script from "./manyidu_page.vue?vue&type=script&lang=js"
export * from "./manyidu_page.vue?vue&type=script&lang=js"
import style0 from "./manyidu_page.vue?vue&type=style&index=0&id=2d30685c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d30685c",
  null
  
)

export default component.exports